import { PropertyValueDto } from "./PropertyValueDto";

export interface ICustomImage{
    Data: string;
    Thumbnail: string;
}

export class OrderDto {
    public Level: string;
    public CustomImage: ICustomImage;
    constructor(
        public OrderEntityId: number,
        public OrderRecordId: number,
        public PropertyValues: PropertyValueDto[],
        public Price : number,
        public Quantity: number,
        customImageDate: string,
        customImageThumbnail: string,
        public Drawing: string) {
            this.CustomImage  = { Data: customImageDate, Thumbnail: customImageThumbnail };
         }
}